import { createPortal } from "react-dom";
import { Upload } from "lucide-react";

// Full-viewport hint raised while a file drag is anywhere over the page.
//
// Portalled to `document.body` so no ancestor's `transform` can become the
// containing block for `fixed` and clip it to a pane. Pointer-events are off so
// the overlay never becomes a drag target itself, which would unbalance the
// dragenter/dragleave depth count the moment it appeared under the cursor.
export const FileDropOverlay = () =>
  createPortal(
    <div className="pointer-events-none fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-3 rounded-2xl border-2 border-dashed border-white/40 px-12 py-10">
        <Upload className="size-10 text-white" aria-hidden />
        <p className="text-lg font-medium text-white">Drop files to attach</p>
        <p className="text-sm text-white/70">They&rsquo;ll be added to your message</p>
      </div>
    </div>,
    document.body
  );
